import React from 'react';

import * as styles from './Tabs.styles';

interface Tab {
  active?: boolean;
  href: string;
  label: string;
}

interface TabsProps {
  ariaLabel?: string;
  tabs: Tab[];
}

export const Tabs = ({ ariaLabel, tabs }: TabsProps) => {
  return (
    <nav aria-label={ariaLabel} css={styles.root}>
      <ul>
        {tabs.map((tab) => {
          return (
            <li key={tab.label}>
              <a aria-current={tab.active ? 'page' : undefined} href={tab.href}>
                {tab.label}
              </a>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
